import Grid from '@material-ui/core/Grid';
import Meal from './Meal';
import React from 'react';
import { MealProps } from '../index';
import type { MealGroupingType } from '../index';

type MealsProps = {
  meals: MealProps,
  mealGrouping: MealGroupingType,
};

const MealsComponent = ({ meals, mealGrouping }: MealsProps) => {
  return (
    <Grid item container>
      {meals.map((data: MealProps) => (
        <Meal key={data.timing} {...data} mealGrouping={mealGrouping} />
      ))}
    </Grid>
  );
};

export default MealsComponent;
